import { useCallback } from 'react';
import { CareersNavId, Department } from 'components/careers/types';
import { useHistory, useLocation } from '@alltrails/shared/components/ReactRouter';
import { getQueryStringValue } from 'hooks/useQueryString';

const useDepartmentHistory = (): { initialDepartment: Department; updateDepartmentHistory: (department: Department) => void } => {
  const history = useHistory();
  const location = useLocation();
  const departmentFromLocation = getQueryStringValue('department', location?.search);

  let initialDepartment: Department = Department.All;
  Object.values(Department).forEach((dep: Department) => {
    if (dep.toLowerCase() === departmentFromLocation) {
      initialDepartment = dep;
    }
  });

  const updateDepartmentHistory = useCallback(
    (department: Department) => {
      history.push({
        pathname: location?.pathname,
        search: `department=${department.toLowerCase()}`,
        hash: `#${CareersNavId.OpenPositions}`
      });
    },
    [location, history]
  );

  return {
    initialDepartment,
    updateDepartmentHistory
  };
};

export default useDepartmentHistory;
